export const SAVE_USER_DATA = "SAVE_USER_DATA";
export const USER_LOGOUT = "USER_LOGOUT";
export const SESSION_EXPIRE = "SESSION_EXPIRE";
